export default "__VITE_ASSET__CtwLKjmD__"